import Repository from "@/services/repository";

export default {
  createTagsAddition(studyId, keywordsTextAndLocationIds, tags) {
    return Repository.post(`/a/${studyId}/keywords/add_tags.json`, {
      keywordsTextAndLocationIds,
      tags,
    }).then((response) => response.data);
  },
};
